import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import AuctionDetail from "./pages/AuctionDetail";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminReset from "./pages/admin/AdminReset";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AuctionForm from "./pages/admin/AuctionForm";
import LocationForm from "./pages/admin/LocationForm";
import SettingsForm from "./pages/admin/SettingsForm";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auction/:id" element={<AuctionDetail />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/reset" element={<AdminReset />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/auction/:id" element={<AuctionForm />} />
        <Route path="/admin/location/:id" element={<LocationForm />} />
        <Route path="/admin/settings" element={<SettingsForm />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
